import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentType, EnvironmentService} from '@utils/services/environment/environment.service';

/**
 * Helper Component
 * Determines based on project and iFrame Environment whether to load widgets or website
 * version of the match-component
 */

@Component({
  selector: 'lib-match-container',
  templateUrl: './match-container.component.html',
  styleUrls: ['./match-container.component.scss']
})
export class MatchContainerComponent implements OnInit {
  public eventId: string;
  public teamId: string;
  protected readonly EnvironmentService = EnvironmentService;
  protected readonly EnvironmentType = EnvironmentType;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.eventId = this.route.snapshot.paramMap.get('eventId');
    this.teamId = this.route.snapshot.paramMap.get('teamId');
  }
}
